import { Button, List } from 'antd';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Brand from "../../Classes/Brand";
import { brandModalSliceDispatch, brandViewerSliceDispatch, pickAFileSliceDispatch } from "../../Constants/ReduxConstants";
import { ReduxHelpers } from "../../Helpers/ReduxHelpers";
import BrandModal from ".././BrandModal/BrandModal";

const BrandViewer = () => {
    const currentBrands = useSelector((state: any) => state.pickAFile.brandList);
    const currentServiceQuestionBrand = useSelector((state: any) => state.pickAFile.serviceBrandQuestions);

    const addModal = useSelector((state: any) => state.brandViewer.addModal);
    const editModal = useSelector((state: any) => state.brandViewer.editModal);
    const currentBrand = useSelector((state: any) => state.brandViewer.currentBrand);

    const dispatch = useDispatch()

    const { CreateContentsFromStates } = ReduxHelpers();

    function DeleteABrand(idToDelete) {
        let filteredBrands = currentBrands.filter(brand => brand.brandId != parseInt(idToDelete) || brand.brandId != idToDelete);
        dispatch({ type: pickAFileSliceDispatch.setBrandList, payload: filteredBrands })

        let filteredServiceQuestionBrands = currentServiceQuestionBrand;
        filteredServiceQuestionBrands = filteredServiceQuestionBrands.filter(sqb => sqb.brandId != parseInt(idToDelete))

        //Delete any serviceQuestionBrand entries containing this brand
        dispatch({ type: pickAFileSliceDispatch.setServiceBrandQuestions, payload: filteredServiceQuestionBrands })

        CreateContentsFromStates({ brandList: filteredBrands });

        return filteredBrands;
    }

    const HandleDelete = (event) => {
        DeleteABrand(event.currentTarget.id)
    }

    const AddModal = (event?: any) => {
        dispatch({ type: brandViewerSliceDispatch.setAddModal, payload: true })
        dispatch({ type: brandViewerSliceDispatch.setEditModal, payload: false })
        dispatch({ type: brandModalSliceDispatch.setOpen, payload: true });
    }

    const EditModal = (event?: any) => {
        dispatch({ type: brandViewerSliceDispatch.setEditModal, payload: true })
        dispatch({ type: brandViewerSliceDispatch.setAddModal, payload: false })
        dispatch({ type: brandModalSliceDispatch.setOpen, payload: true });
    }

    let defaultNewBrand = new Brand();  //Empty default question

    const brands =
        <div>
            <Button
                onClick={() => {
                    AddModal(); dispatch({ type: brandModalSliceDispatch.setBrandToAdd, payload: defaultNewBrand }); dispatch({ type: brandViewerSliceDispatch.setCurrentQuestion, payload: defaultNewBrand });
                }}>
                Add A new Brand
            </Button>
            <BrandModal />
            <List>
                {currentBrands?.sort((a, b) => a.brandName > b.brandName ? 1 : -1).map(currentBrand =>
                    <div>
                        <List.Item key={currentBrand.brandName}>

                            <Button onClick={() => {
                                EditModal(); dispatch({ type: brandModalSliceDispatch.setBrandToAdd, payload: currentBrand }); dispatch({ type: brandViewerSliceDispatch.setCurrentQuestion, payload: currentBrand });
                            }}>
                                Edit
                            </Button>
                            <Button id={currentBrand.brandId} onClick={HandleDelete}>Delete</Button>
                            {currentBrand.brandName}
                        </List.Item>
                    </div>
                )}
            </List>
        </div>
    return <div>{brands}</div>
}

export default BrandViewer;